module.exports = __webpack_public_path__ + "img/logo_icon@2x.cb37ad1c.png";